import React, { useState } from 'react';
import InlineDatePicker, {
  InlineDatePickerProps
} from '@components/DatePickerComponent/InlineDatePicker';
import { Popover, PopoverProps } from 'antd';

interface DatePickerPopoverProps extends InlineDatePickerProps {
  className?: string;
  trigger?: PopoverProps['trigger'];
  open?: PopoverProps['open'];
  onOpenChange?: PopoverProps['onOpenChange'];
  placement?: PopoverProps['placement'];
  getPopupContainer?: PopoverProps['getPopupContainer'];
  placeholder?: string;
  children?: PopoverProps['children'];
  clearableTime?: boolean;
}

export default function DatePickerPopover(props: DatePickerPopoverProps) {
  const {
    className,
    trigger,
    placement,
    children,
    open,
    onOpenChange,
    getPopupContainer,
    onChange,
    ...otherProps
  } = props;
  const [isOpen, setIsOpen] = useState(open ?? false);
  if (open !== undefined && open !== isOpen) {
    setIsOpen(open);
  }
  return (
    <Popover
      className={className}
      getPopupContainer={getPopupContainer}
      placement={placement}
      trigger={trigger}
      open={isOpen}
      onOpenChange={(v) => {
        setIsOpen(v);
        if (onOpenChange) onOpenChange(v);
      }}
      overlayClassName="popover-container date-picker-popover-container"
      content={
        <InlineDatePicker
          {...otherProps}
          onChange={(v) => {
            if (onChange) onChange(v);
          }}
        />
      }
    >
      {children}
    </Popover>
  );
}
